import React from 'react';

import { FormattedMessage } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import { isInternalURL } from '@plone/volto/helpers/Url/Url';
import ButtonView from '../Button/View';

export function getSubscribeImageURL(image) {
  let image_url = '';
  if (image) {
    if (isInternalURL(image['@id'])) {
      image_url = `${image['@id']}/@@images/image`;
    } else {
      image_url = image['@id'];
    }
  }
  return flattenToAppURL(image_url);
}

const SubscribeView = (props) => {
  const { data } = props;

  const image = data.image?.[0];

  return (
    <div
      className="subscribe-wrapper"
      style={
        image
          ? {
              backgroundImage: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75)), url(${getSubscribeImageURL(image)})`,
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              alignItems: 'end',
              paddingBottom: '80px',
            }
          : {}
      }
    >
      <div className="subscribe-content-wrapper">
        <div className="subscribe-title">
          {data.title && <h2>{data?.title} </h2>}
        </div>
        <ButtonView
          key=""
          className="primary subscribe-button"
          data={{
            href: data.href,
            title: (
              <FormattedMessage id="Subscribe" defaultMessage="Subscribe" />
            ),
          }}
          isEditMode={props.isEditMode}
        />
      </div>
    </div>
  );
};

export default SubscribeView;
